// extracted by mini-css-extract-plugin
export default {"searchResults":"peopleSearchResults_searchResults__CbAVg","personResult":"peopleSearchResults_personResult__CEjkC"};